import * as Sentry from '@sentry/browser';

declare var APP_ENV: string;
declare var APP_RELEASE: string|undefined;

if (APP_ENV !== 'local') {
    const dsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute('content');

    if (typeof dsn === 'undefined' || dsn === null) {
        throw new Error('Sentry DSN not found. Expected to find <meta name="sentry-dsn" content="...">')
    }

    Sentry.init({
        dsn: dsn,
        environment: APP_ENV,
        release: APP_RELEASE,
        integrations: [],
        tracesSampleRate: 1.0,
        allowUrls: [/https:\/\/(stage-myae|myaeadmin).advancedenergy\.com/],
        ignoreErrors: [
            "MktoForms2 is not defined", // occurs in GTM code
            "Can't find variable: MktoForms2", // occurs in GTM code
            "'getBoundingClientRect' called on an object that does not implement interface Element.", // occurs in OneTrust code
            "Document.querySelector: 'input[name=[object HTMLOptionElement]]' is not a valid selector", // occurs in GTM code
            "Munchkin is not defined", // occurs in GTM code
            "Load failed", // occurs in GTM code
        ],
    });
}
